module.exports = __webpack_public_path__ + "img/unrevealed.45304401.gif";